/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autosave_SavingInputs */

const cs_autosave_saving = /** @type {(inputs: Autosave_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukládání…`)
};

const en_autosave_saving = /** @type {(inputs: Autosave_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Autosave_SavingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const autosave_saving = /** @type {((inputs?: Autosave_SavingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autosave_SavingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_autosave_saving(inputs)
	return cs_autosave_saving(inputs)
});